import React from 'react';
import { Menu } from '../../components/Menu/Menu';
import { isRouteSuperAdmin } from '../../services/salesRoutesService';
import { SalesRoutesScreen } from './SalesRoutes';
import styles from '../../css/SalesRoutes.module.css';

/**
 * SalesRoutesAuthorization — consulta de rutas para autorizarlas o rechazarlas.
 * Es la misma pantalla que SalesRoutes en modo revisión. El acceso sale de isRouteSuperAdmin()
 * en salesRoutesService.js; ver su "TODO: BACKEND".
 */
export default function SalesRoutesAuthorization() {
    if (!isRouteSuperAdmin()) {
        return (
            <div className={styles.page}>
                <Menu />
                <div className={styles.denied}>This view is only available to administrators.</div>
            </div>
        );
    }
    return <SalesRoutesScreen reviewMode />;
}
